export default __webpack_public_path__ + "static/media/spaces_in_london_256.af333ab0.jpg";